module.exports = __webpack_public_path__ + "static/media/ends_with_p.2f607b7b.mp3";